import { render, staticRenderFns } from "./ExportTabButton.vue?vue&type=template&id=a39a31de&"
import script from "./ExportTabButton.vue?vue&type=script&lang=js&"
export * from "./ExportTabButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a39a31de')) {
      api.createRecord('a39a31de', component.options)
    } else {
      api.reload('a39a31de', component.options)
    }
    module.hot.accept("./ExportTabButton.vue?vue&type=template&id=a39a31de&", function () {
      api.rerender('a39a31de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchpointInfo/ExportTabButton.vue"
export default component.exports